export default {"src":"/_next/static/media/premium_king.760dbe5f.svg","height":20,"width":25};